// import styleReset from '../reset.shadow.less';
import styleLanguageSelector from './language-selector.shadow.less';

// === 語言切換選單 === //
class LanguageSelector extends HTMLElement {
    constructor(){
        super();

        this.root = this.attachShadow({ mode: 'open' });

        // this.applyStyle(styleReset);
        this.applyStyle(styleLanguageSelector);

        // 初始化 shadow DOM 結構 (不含內容)
        // this.init();

        // 必須手動綁定 this，否則不會正確的指向 this (web component 實體)
        // this._handleResize = this._handleResize.bind(this);
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        // 初始化 shadow DOM 結構 (不含內容)
        // const wrapper = document.createElement('div');
        // wrapper.className = 'wrapper';
        // this.root.appendChild(wrapper);
    }

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    connectedCallback(){
        // addEventListener
        // window.addEventListener('resize', this._handleResize);

        this.root.addEventListener('click', (event) => {
            const langBtn = event.target.closest('.btn');
            if(langBtn){
                document.body.classList.add('loading');
                localStorage.setItem('user-lang', langBtn.dataset.lang);
                location.reload();
            }
        });
    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    // disconnectedCallback(){
        // 綁定在 shadoe DOM 的事件監聽器會被自動移除，不用手動移除
        // 除此之外都需要手動移除
        // window.removeEventListener('resize', this._handleResize);
    // }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // attributeChangedCallback(name, oldValue, newValue){
        // if(name === 'title'){
        //     // 例如更新文字內容
        //     // console.log(newValue); // -> Alice
        // }
        // if(name === 'active'){
        //     this.root.querySelector('p.active').textContent =
        //     `狀態:${newValue}`;
        // }
    // }

    // === 此處列出的屬性才會被 attributeChangedCallback 追蹤 === //
    // static get observedAttributes() {
        // return ['title', 'active'];
    // }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // 很少用，一般可略過
    // adoptedCallback(){

    // }

    // *** 以下為自訂方法 *** //

    // seeter 從外部接收資料
    // 當資料改變時可做相應的處理，例如更新內容等
    /** @param {(Object|Array)} [data=null] - 傳入資料 */
    set setData(data = null){
        this.render(data);
    }

    // === 根據資料產生內容 === //
    render(data){
        if(!data){
            return;
        }

        const currLang = window.currLang

        data.forEach((item) => {
            const btn = document.createElement('div');
            btn.className = 'btn';
            btn.textContent = item.label;
            btn.dataset.lang = item.code;

            if(currLang === item.code){
                btn.classList.add('current');
            }

            this.root.appendChild(btn);
        });
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

    // === window.resize === //
    // _handleResize(){
        // 需要注意，以這個綁定在 window 上的事件處理器為例
        // 如果在 constructor 中不手動綁定 this
        // this._handleResize = this._handleResize.bind(this);
        // 那麼這邊預設指向的 this 會變成 window（或 undefined，如果是 strict mode）
    // }

}

customElements.define('language-selector', LanguageSelector);